import SettingUiManagement from "./setting-ui-management.page";

export default SettingUiManagement;
